import { css } from '@styled-system/css';
import type { FC } from 'react';

import { InteractionOverlay, type InteractionOverlayItem } from '@/shared/components/ui/InteractionOverlay';

interface MainSidebarUserProfileProps {
  username: string;
  onSubscriptionClick: () => void;
  onSettingsClick: () => void;
  onLogoutClick: () => void;
}

export const MainSidebarUserProfile: FC<MainSidebarUserProfileProps> = ({
  username,
  onSubscriptionClick,
  onSettingsClick,
  onLogoutClick,
}) => {
  const containerStyles = css({
    display: 'flex',
    alignItems: 'center',
    gap: 'xs',
  });

  const userInfoStyles = css({
    w: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: 'sm',
    lineHeight: 0,
  });

  const usernameStyles = css({
    fontSize: '8px',
    fontWeight: 600,
    color: 'font.muted',
    textAlign: 'left',
    lineHeight: 1.5,
    flexGrow: 1,
    maxW: '7rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  });

  const menuItems: InteractionOverlayItem[] = [
    {
      icon: 'crown',
      label: 'Abonnement',
      onClick: onSubscriptionClick,
    },
    {
      icon: 'param',
      label: 'Paramètres',
      onClick: onSettingsClick,
    },
    {
      danger: true,
      icon: 'logout',
      label: 'Se déconnecter',
      onClick: onLogoutClick,
    },
  ];

  return (
    <div className={containerStyles}>
      <div className={css({ w: '0.7rem', minW: '0.7rem', h: '0.7rem', minH: '0.7rem' })}>
        <svg width="100%" height="100%" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0ZM9 12.5156C6.98073 12.5156 5.34375 14.1526 5.34375 16.1719C5.34375 16.2103 5.33884 16.2477 5.33203 16.2842C6.43494 16.8406 7.68031 17.1562 9 17.1562C10.3194 17.1562 11.5643 16.8404 12.667 16.2842C12.6602 16.2478 12.6562 16.2103 12.6562 16.1719C12.6562 14.1526 11.0193 12.5156 9 12.5156ZM9 0.84375C4.49543 0.84375 0.84375 4.49543 0.84375 9C0.84375 11.6937 2.14987 14.0822 4.16309 15.5674C4.46084 13.1603 6.51236 11.2969 9 11.2969C11.4873 11.2969 13.5377 13.1598 13.8359 15.5664C15.8492 14.0812 17.1562 11.6938 17.1562 9C17.1562 4.49543 13.5046 0.84375 9 0.84375ZM9 4.59375C10.6827 4.59375 12.0469 5.95788 12.0469 7.64062C12.0469 9.32337 10.6827 10.6875 9 10.6875C7.31728 10.6875 5.95312 9.32335 5.95312 7.64062C5.95312 5.9579 7.31728 4.59377 9 4.59375ZM9 5.8125C7.99037 5.81252 7.17188 6.63099 7.17188 7.64062C7.17188 8.65026 7.99037 9.46873 9 9.46875C10.0096 9.46875 10.8281 8.65027 10.8281 7.64062C10.8281 6.63098 10.0096 5.8125 9 5.8125Z"
            fill="#B3B5BD"
          />
        </svg>
      </div>
      <div className={userInfoStyles}>
        <p className={usernameStyles}>{username}</p>
      </div>
      <InteractionOverlay orientation="vertical" items={menuItems} />
    </div>
  );
};
